import React from 'react';
import { Users, Plus } from 'lucide-react';

const StaffManagement = ({ locationId }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white mb-1">Staff Management</h2>
          <p className="text-gray-400">Manage staff schedules, roles, and attendance</p>
        </div>
        <button className="flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-black font-medium px-4 py-2 rounded-lg transition-colors">
          <Plus size={18} />
          Add Staff Member
        </button>
      </div>

      {/* Placeholder Content */}
      <div className="bg-gray-900 rounded-lg p-8 text-center">
        <Users className="mx-auto text-gray-600 mb-4" size={48} />
        <h3 className="text-xl font-bold text-white mb-2">Staff Management</h3>
        <p className="text-gray-400">Staff management functionality will be implemented here.</p>
        <p className="text-gray-500 text-sm mt-2">Location ID: {locationId}</p>
      </div>
    </div>
  );
};

export default StaffManagement;